<template>
    <div class="qwewqdsad">
        <el-dialog :title="titleName" class="wwweditcss" width="60%" :visible.sync="dialogFormVisible">
            <div id="aprication">
                <div class="headerp-div">
                    <div class="header-div">
                        <div style="float: right">
                            <el-button size="mini" v-if="$hasPerm('business:reportStatisticalFormula:add')"
                                       @click="handleAdd()" style=";background-color:#16E3A1;color: white">保存<i
                                    class="el-icon-plus"></i></el-button>
                        </div>
                        <div style="float: left;vertical-align: center;margin: 5px;">
                            选择统计项：
                        </div>
                        <div style="float: left;margin-right: 50px;">
                            <el-select v-model="form.kmId" size="mini" filterable clearable placeholder="请选择">
                                <el-option
                                        v-for="item in itemList"
                                        :key="item.id"
                                        :label="item.itemCode+' '+ item.itemName"
                                        :value="item.id">
                                </el-option>
                            </el-select>
                        </div>
                        <div style="float: left;vertical-align: center;margin: 5px;">
                            运算符号：
                        </div>
                        <div style="float: left;">
                            <el-select size="mini" v-model="form.ysfh" placeholder="请选择运算符号">
                                <el-option value="+" label="+"/>
                                <el-option value="-" label="-"/>
                            </el-select>
                        </div>
                    </div>
                </div>
                <el-table :data="tableData" border size="mini" height="300" style="width: 100%">
                    <el-table-column prop="kmmc" width="520" label="统计项">
                        <template slot-scope="scope">
                            {{scope.row.kmdm}} {{scope.row.kmmc}}
                        </template>
                    </el-table-column>
                    <el-table-column prop="ysfh" label="运算符号"></el-table-column>
                    <el-table-column label="操作"
                                     v-if="$hasPerm('business:reportStatisticalFormula:edit,business:reportStatisticalFormula:remove')">
                        <template slot-scope="scope">
                                <el-button size="mini" slot="reference"
                                           @click="handleDelete(scope.$index, scope.row)"
                                           v-if="$hasPerm('business:reportStatisticalFormula:remove') && scope.row.id != null" type="text">
                                    删除<i class="el-icon-delete"></i>
                                </el-button>
                        </template>
                    </el-table-column>
                </el-table>
            </div>
        </el-dialog>
    </div>
</template>
<script>
    export default {
        name: 'suanshu',
        data() {
            return {
                tableData: [],
                itemList: [],
                editVisible: false,
                dialogFormVisible: false,
                titleName:'',
                form: {
                    tjxId: '',
                    kmId: '',
                    ysfh: ''
                }
            }
        },
        methods: {
            int(itemId,reportCode,itemName) {

                this.titleName = '算数-设置（'+itemName+'）统计项公式'

                this.searchItemList(reportCode);

                this.form.tjxId = itemId;
                this.form.kmId = '';
                this.form.ysfh = '';

                this.dialogFormVisible = true;
                this.handleCurrentChange();
            },
            handleCurrentChange() {
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl('/business/reportStatisticalFormula/list'),
                    method: 'get',
                    params: {
                        'tjxId': this.form.tjxId
                    }
                }).then(r => {
                    this.tableData = r.data.data;
                }).finally(r => {
                })
            },
            handleAdd() {

                if (!this.form.tjxId) {
                    this.$message({
                        type: 'warning',
                        message: '统计项ID不能为空！'
                    })
                    return false;
                }

                if (!this.form.kmId) {
                    this.$message({
                        type: 'warning',
                        message: '请选择添加科目(或统计项)！'
                    })
                    return false;
                }

                if (!this.form.ysfh) {
                    this.$message({
                        type: 'warning',
                        message: '请选择运算符号！'
                    })
                    return false;
                }

                this.$httpTAG({
                    url: this.$httpTAG.adornUrl("/business/reportStatisticalFormula/save"),
                    method: 'post',
                    data: this.$httpTAG.adornData({
                        ...this.form
                    })
                }).then(res => {
                    if (res.data.code == 0) {
                        this.$notify({
                            title: '操作成功！',
                            type: 'success',
                            offset: 600
                        });
                        this.handleCurrentChange();
                    } else {
                        this.$message({
                            type: 'warning',
                            message: res.data.msg
                        })
                    }
                })
            },
            searchItemList(reportCode) {
                this.$httpTAG({
                    url: this.$httpTAG.adornUrl("/business/reportItem/searchItemList"),
                    method: 'post',
                    data: {"reportCode": reportCode}
                }).then(res => {
                    if (res.data.code == 0) {
                        this.itemList = res.data.data;
                    } else {
                        this.$message({
                            type: 'warning',
                            message: res.data.msg
                        })
                    }
                })
            },
            handleDelete(index, row) {
                this.$confirm('确定删除吗?', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    let id = row.id;
                    this.$httpTAG({
                        url: this.$httpTAG.adornUrl('/business/reportStatisticalFormula/remove'),
                        method: 'post',
                        data: this.$httpTAG.adornData({
                            'id': id
                        })
                    }).then(res => {
                        if (res.data.code == 0) {
                            this.$notify({
                                title: '操作成功！',
                                type: 'success',
                                offset: 600
                            });
                            this.handleCurrentChange();
                        } else {
                            this.$message({ // 失败
                                type: 'error',
                                message: res.data.msg
                            })
                        }
                    })
                }).catch(() => {
                });
            }
        }
    }
</script>
<style scoped>
    .header-div {
        margin-bottom: 5px;
        float: left;
        width: 100%;
        text-align: right;
        border: #EBEEF5 1px solid;
        padding: 10px;
    }

    .queryInput >>> .el-input__inner {
        border-radius: 0px;
        width: 200px;
    }

    .wwweditcss >>> .el-dialog__body {
        padding: 10px 35px 25px 35px;
        height: 420px;
    }

    .qwewqdsad >>> .el-table tr:hover {
        text-decoration: none!important;
    }
</style>